export default __webpack_public_path__ + "static/media/italy.icon.6cc76946.svg";